$('.content_outer_inner').slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,

  // Append arrows inside this class
  appendArrows: $('.custom_arrows'),

  prevArrow: `
    <button type="button" class="slick-prev">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 2L7 10L15 18" stroke="white" stroke-width="2"/>
      </svg>
    </button>
  `,

  nextArrow: `
    <button type="button" class="slick-next">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 18L13 10L5 2" stroke="white" stroke-width="2"/>
      </svg>
    </button>
  `
});



